import React from 'react';
import ReactDom from 'react-dom';
import { isMobile } from '../../utils/screen';

function PopUpWrapper({
	children,
	colors,
	open = false,
	setOpen,

	/* OPTIONAL PROPS */
	classNameModal = '',
	styleModal,
	styleOverlay,
}) {
	/* Default values for the styles */
	const defaultStyleModal = {
		position: 'fixed',
		top: '50%',
		width: !isMobile ? '60%' : '100%',
		left: '50%',
		transform: 'translate(-50%, -50%)',
		backgroundColor: `${colors?.background}`,
		transition: 'all 100ms ease-in',
		zIndex: 1000,
	};
	const defaultStyleOverlay = {
		position: 'fixed',
		top: 0,
		left: 0,
		right: 0,
		bottom: 0,
		backgroundColor: 'rgba(0, 0, 0, 0.77)',
		transition: 'all 100ms ease-in',
		zIndex: 1000,
	};

	/* This allows for only one of the fields to be modified and still keep the other constant values */
	const overrideStyleModal = { ...defaultStyleModal, ...styleModal };
	const overrideStyleOverlay = { ...defaultStyleOverlay, ...styleOverlay };

	if (!open) return null;

	return ReactDom.createPortal(
		<React.Fragment>
			<div style={overrideStyleOverlay} onClick={() => setOpen(false)} />
			<div
				className={classNameModal}
				style={overrideStyleModal}
			>
				{children}
			</div>
		</React.Fragment>,
		document.getElementById('portal')
	);
}

export default PopUpWrapper;
